import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import AttractionsPage from '../views/AttractionsPage.vue'
import featuredAttractions  from '../components/elements/FeaturedAttractionCard.vue'
import SceneDetail from '@/components/elements/SceneDetail.vue'
import TravelPassage from '@/components/elements/TravelPassage.vue'
import MapApi from '@/components/elements/MapApi.vue'
import Model from '@/components/3D/Yingxian3Dmodel.vue'
import AboutUs from '@/views/AboutUs.vue'
import AdminPage from '@/views/AdminPage.vue'
import CultureExperience from '@/components/elements/CultureExperience.vue'
import EighteenDelicious from '@/components/elements/EighteenDelicious.vue'
import ChatModel from '@/components/elements/ChatModel.vue'
const routes = [
  {
    path: '/home',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/chat',
    name: 'chat',
    component: ChatModel
  },
  {
    path: '/eighteen',
    name: 'eighteen',
    component: EighteenDelicious
  },
  {
    path: '/cultureexperience',
    name: 'cultureexperience',
    component: CultureExperience
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminPage
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    component: AboutUs
  },
  {
    path: '/model',
    name: 'model',
    component: Model
  },
  {
    path: '/mapapi',
    name: 'mapapi',
    component: MapApi
  },
  {
    path: '/passage/:name',
    name: 'passage',
    component: TravelPassage
  },
  {
    path: '/scene/:id',
    name: 'Scene',
    component:SceneDetail
  },
  {
    path: '/attractions',
    name: 'Attractions',
    component: AttractionsPage
  },
  {
    path: '/attractions/:id',
    name: 'AttractionDetail',
    component: () => import('../views/AttractionDetailPage.vue')
  },
  {
    path: '/guides',
    name: 'Guides',
    component: () => import('../views/GuidesPage.vue')
  },
  {
    path: '/map',
    name: 'Map',
    component: () => import('../views/MapPage.vue')
  },
  {
    path: '/culture',
    name: 'Culture',
    component: () => import('../views/CulturePage.vue')
  },
  {
    path: '/featuredAttractions',
    name: 'featuredAttractions',
    component: featuredAttractions
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutPage.vue')
  },
  {
    path: '/CommentDetail',
    name: 'CommentDetail',
    component: () => import('../views/CommentDetail.vue')
  },
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/LoginPage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  // scrollBehavior() {
  //   return { top: 0 }
  // }
})

export default router